import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "@entur-partner/common";
import { Heading1 } from "@entur/typography";

export function NotFound() {
  const { t } = useTranslation();

  useDocumentTitle({ title: t("common.page-not-found") });

  return <Heading1>{t("common.page-not-found")}</Heading1>;
}
